var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("table", { staticClass: "table table-hover table-sm mt-1" }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "tbody",
        _vm._l(_vm.orders, function (o, i) {
          return _c(
            "tr",
            {
              key: o.id,
              class: { selected: _vm.compareSum === o.no_cash_price },
            },
            [
              _c("td", [
                _c("p", { staticClass: "border" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-xs btn-info mr-1",
                      on: {
                        click: function ($event) {
                          return _vm.openOrderInModal(o.id)
                        },
                      },
                    },
                    [_c("i", { staticClass: "icon-fa icon-fa-eye" })]
                  ),
                  _vm._v("\n          " + _vm._s(o.id) + "\n        "),
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(_vm._s(o.project_label) + "\n          "),
                  _c("span", {
                    domProps: { innerHTML: _vm._s(_vm.printOrderStatus(o)) },
                  }),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "text-muted" }, [
                  _vm._v(_vm._s(_vm.printDate(o.created_at))),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "td",
                [
                  _c("p", [_vm._v(_vm._s(o.client_name))]),
                  _vm._v(" "),
                  _vm._l(o.order_phones, function (p) {
                    return _c(
                      "div",
                      { staticClass: "flex align-items-center border" },
                      [
                        _c(
                          "MakeCall",
                          { attrs: { phone: p.phone, order: o } },
                          [
                            _vm._t("default", function () {
                              return [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-xs btn-success mr-1",
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "icon-fa icon-fa-phone-square",
                                    }),
                                  ]
                                ),
                              ]
                            }),
                          ],
                          2
                        ),
                        _vm._v(
                          "\n          " + _vm._s(p.phone.phone) + "\n        "
                        ),
                      ],
                      1
                    )
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c("td", [_c("p", [_vm._v(_vm._s(o.address))])]),
              _vm._v(" "),
              _c(
                "td",
                _vm._l(o.details, function (d) {
                  return _c("p", [
                    _vm._v(
                      _vm._s(d.new_drug.title) + " x " + _vm._s(d.qty) + " x "
                    ),
                    _c("strong", [_vm._v(_vm._s(d.price))]),
                  ])
                }),
                0
              ),
              _vm._v(" "),
              _c("td", [
                _c(
                  "div",
                  { staticClass: "flex" },
                  [
                    _c("PrePaidButton", { attrs: { order: o } }),
                    _vm._v(" "),
                    _c("p", { staticClass: "text-center" }, [
                      _c("strong", [_vm._v(_vm._s(o.no_cash_price))]),
                    ]),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c(
                "td",
                [
                  _c("LoadingButton", {
                    attrs: {
                      title: "подтвердить",
                      className: "btn btn-success btn-xs",
                      onClick: () => _vm.makePair(o),
                      loading: _vm.loadingBtn[o.id],
                      color: _vm.$constants.LOADING_COLOR,
                    },
                  }),
                ],
                1
              ),
            ]
          )
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", { attrs: { width: "150px" } }, [_vm._v("Заявка")]),
        _vm._v(" "),
        _c("th", [_vm._v("Клиент")]),
        _vm._v(" "),
        _c("th", [_vm._v("Адрес")]),
        _vm._v(" "),
        _c("th", [_vm._v("Препараты")]),
        _vm._v(" "),
        _c("th", [_vm._v("Сумма для карты")]),
        _vm._v(" "),
        _c("th"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }